import { Grid, Image, List, Paper, Text, Flex } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';
import { RiVipCrownFill } from "react-icons/ri";
import "./RankingCard.css";
import NusLogo from "../../../images/NusLogo.png";
import FgvLogo from "../../../images/FgvLogo.png";
import MsuLogo from "../../../images/MsuLogo.jpg";

export default function RankingCard({user, rank, currUser}) { 
    const isMobile = useMediaQuery('(max-width: 1090px)');
    return <List.Item p="lg" className={currUser ? "gradient-border" : "border-top-gray"}>
        <Grid align="center">
            <Grid.Col span={1}>
                <Text inline className={(rank <= 3 ? (rank === 1 ? "gold" : rank === 2 ? "silver" : "bronze") : "")} >{rank}</Text> 
            </Grid.Col>
            <Grid.Col span="content" align="center" justify="center">          
                <Paper pos="relative" shadow="sm" radius={9999} withBorder>
                    <Image className={rank <= 3 ? "rank " + (rank === 1 ? "gold" : rank === 2 ? "silver" : "bronze") : ""} 
                        alt="user image" src={user.university === "National University of Singapore" 
                            ? NusLogo
                            : (user.university === "FGV" 
                                ? FgvLogo
                                : MsuLogo)}
                        width={isMobile ? 60: 48} height={isMobile ? 60 : 48} fit="cover" radius={9999} />
                    {rank === 1 ? <RiVipCrownFill className="crown" /> : null}
                </Paper> 
            </Grid.Col>

            <Grid.Col span={isMobile ? 7 : 5}>
                <Text weight="bold" size="sm"
                    color={user.university === "National University of Singapore" 
                            ? "var(--color-nuswap-brand-1)" 
                            : (user.university === "FGV" 
                                ? "var(--color-nuswap-secondary-2)" 
                                : "blue")}>{user.university}</Text>
                {currUser ? <Text weight="bolder">You</Text> : <Text weight="bolder">{user.alias}</Text>}
                {isMobile && <Flex align="center" wrap="nowrap" justify="flex-start" columnGap={3}>
                    <Text size="sm" inline align="left">Total P/L:</Text>
                    <Text size="sm" inline>{user.weekly_return}</Text>
                </Flex>}
                {isMobile && <Flex align="center" wrap="nowrap" justify="flex-start" columnGap={3}>
                    <Text size="sm" inline align="left">Drawdown:</Text>
                    <Text size="sm" inline>{user.weekly_maxdrawdown}%</Text>
                </Flex>}
            </Grid.Col>

            {!isMobile && <Grid.Col span={2}>
                <Text size="sm" align="left">Total P/L:</Text>
                <Text size="sm">{user.weekly_return}</Text>
            </Grid.Col>}
            
            {!isMobile && <Grid.Col span={2}>
                <Text size="sm" align="left">Drawdown:</Text>
                <Text size="sm">{user.weekly_maxdrawdown}%</Text>
            </Grid.Col>}
        </Grid>
    </List.Item>
}
